import { render, staticRenderFns } from "./AnswView.vue?vue&type=template&id=08625666&scoped=true"
import script from "./AnswView.vue?vue&type=script&lang=js"
export * from "./AnswView.vue?vue&type=script&lang=js"
import style0 from "./AnswView.vue?vue&type=style&index=0&id=08625666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08625666",
  null
  
)

export default component.exports